<template>
    <div>
        <div class="common-items-center line" style="margin-bottom: 20px;">
             <div class="peizhi">推送配置:</div>
             <div v-for="(item,index) in listData" :key="index">
                 <div class="btn"  :class='[tabIndex == item.indexNo*1 ? "active":""]' @click="tabBtn(item)">{{item.title}}</div>
            </div>
        </div>
        <el-form  label-width="70px">
            <div class="common-items-center common-space-between" >
                <el-form-item  label="模版选择">
                    <SelectBlock keyVal="templateId" ref="templateId" :size="null"   placeholder="请选择" :options="listData[tabIndex].templist" left="0" right="0"  width="210" @getVal="getSelectVal" />
                </el-form-item> 
                <div class="common-items-center">
                    <el-form-item  label="间歇时长">
                        <el-input-number v-model="listData[tabIndex].list.pushInput"  controls-position="right"   @change="getPushInput" :min="0" :max="100" style="width:100px;margin-right:10px;" placeholder="请输入值" ></el-input-number> 
                    </el-form-item> 
                    <div class="common-relatives" style="bottom:10px;">
                        <SelectBlock keyVal="unitRate" ref="unitRate"  :size="null"   left="0" right="0" :options="intermList" width="120" @getVal="getSelectVal" />
                    </div> 
                </div>
            </div>
            <div class="common-items-center common-space-between">
                <el-form-item  label="推送次数"  >
                    <el-input-number v-model="listData[tabIndex].list.policeSumCount"  controls-position="right" style="width:210px"   @change="getPoliceSumCount" :min="0" :max="100"  placeholder="请输入值" ></el-input-number> 
                </el-form-item>
                <el-form-item  label="推送状态">
                    <SelectBlock keyVal="enable" ref="enable" :size="null"  title="" left="0" right="0"  width="230" @getVal="getSelectVal" />
                </el-form-item> 
            </div>
            <el-form-item  label="模版内容">
                <el-input  type="textarea" :readonly="true"  :autosize="{minRows:2,maxRows:6}" v-model="listData[tabIndex].list.content"/>
            </el-form-item> 
        </el-form>
    </div>
</template>
<script>
  import {conText} from '@/utils/configText'
   export default {
      data:()=>({
        tabIndex:0,
        dtId:0,
        intermList:[],                  //间歇时长列表
        listData:[

            {
                indexNo:0,
                title:"语音",
                pushMethod:1,
                mark:"voice",
                list:{
                    pushRate:0,         //间歇时长转换成秒 
                    templateId:"",      //模版ID,
                    pushMethod:1,        //1语音 2短息 3公众号  4系统
                    policeSumCount:1,   //循环次数
                    enable:0,           //推送状态 0禁用 1启用
                    unitRate:1,         //1=秒，2=分钟，3=小时，4=天，5=周
                    //额外内容无需上传到服务器
                    pushInput:0,        //间歇时长输入值
                    content:"",         //模版内容
                }, 
            },
            {
                indexNo:1,
                title:"短信",
                pushMethod:2,
                mark:"mess",
                list:{
                    pushRate:0,         //间歇时长 
                    templateId:"",      //模版ID,
                    pushMethod:2,       //1语音 2短息 3公众号  4系统
                    policeSumCount:1,   //循环次数
                    enable:0,           //推送状态 0禁用 1启用
                    unitRate:1,         //1=秒，2=分钟，3=小时，4=天，5=周

                    //额外内容无需上传到服务器
                    pushInput:0,        //间歇时长输入值
                    content:"",         //模版内容
                }, 
            },
            {
                indexNo:2,
                title:"公众号",
                pushMethod:3,
                mark:"account",
                list:{
                    pushRate:0,         //间歇时长 
                    templateId:"",      //模版ID,
                    pushMethod:3,       //1语音 2短息 3公众号  4系统
                    policeSumCount:1,   //循环次数
                    enable:0,           //推送状态 0禁用 1启用
                    unitRate:1,         //1=秒，2=分钟，3=小时，4=天，5=周
                    //额外内容无需上传到服务器
                    pushInput:0,        //间歇时长输入值
                    content:"",         //模版内容
                }, 
            },
            {
                indexNo:3,
                title:"系统",
                pushMethod:4,
                mark:"system",
                list:{
                    pushRate:0,         //间歇时长转换成秒 
                    templateId:"",      //模版ID,
                    pushMethod:4,       //1语音 2短息 3公众号  4系统
                    policeSumCount:1,   //循环次数
                    enable:0,           //推送状态 0禁用 1启用
                    unitRate:1,         //1=秒，2=分钟，3=小时，4=天，5=周
                    //额外内容无需上传到服务器
                    pushInput:0,        //间歇时长输入值
                    content:"",         //模版内容
                }, 
            },
        ]
      }),
      mounted(){
            this.intermList = conText.timeData
      },
      methods:{

        //获取对应的数据
        getdataFun(ev){
           
            this.$set(this.listData[0],"templist",ev.voiceTemp)
            this.$set(this.listData[1],"templist",ev.duxinTemp)
            this.$set(this.listData[2],"templist",ev.pubicTemp)
            this.$set(this.listData[3],"templist",ev.systemTemp)
            if(ev.echoList.mark=="add"){
                
                this.$set(this.listData[0].list,"templateId",ev.voiceTemp[0].id)
                this.$set(this.listData[1].list,"templateId",ev.duxinTemp[0].id)
                this.$set(this.listData[2].list,"templateId",ev.pubicTemp[0].id)
                this.$set(this.listData[3].list,"templateId",ev.systemTemp[0].id)
            }else{
                let pushConfigs = ev.echoList.listData.pushConfigs
                if(pushConfigs.length != this.listData.length){
                    pushConfigs.push({
                        createTime:'',
                        enable:0,
                        id:'',
                        policeConfigId:'',
                        policeSumCount:1,
                        ptContent:ev.systemTemp[0].content,
                        ptName:ev.systemTemp[0].ptName,
                        pushMethod:4,
                        templateId:ev.systemTemp[0].id,
                        pushRate:0,
                        unitRate:1 
                    })
                }
                for(var i in pushConfigs){
                    this.$set(this.listData[i].list,"id",pushConfigs[i].id)
                    this.$set(this.listData[i].list,"policeConfigId",pushConfigs[i].policeConfigId)
                    this.$set(this.listData[i].list,"templateId",pushConfigs[i].templateId)
                    this.$set(this.listData[i].list,"unitRate",pushConfigs[i].unitRate)
                    this.$set(this.listData[i].list,"policeSumCount",pushConfigs[i].policeSumCount)
                    this.$set(this.listData[i].list,"enable",pushConfigs[i].enable)
                    let timeData = conText.timeData
                    for(var j in timeData){
                       if(timeData[j].indexNo==pushConfigs[i].unitRate){
                          this.$set(this.listData[i].list,"pushMark",timeData[j].val)
                          this.$set(this.listData[i].list,"pushInput", pushConfigs[i].pushRate/timeData[j].val)
                       } 
                    }
                }
            }
            this.$nextTick(res=>{
                this.tabBtn({indexNo:this.listData[0].indexNo})
            })
        },
        //切换不同的配置
        tabBtn(ev){
           this.tabIndex = ev.indexNo*1
           this.$nextTick(res=>{
               let datas = this.listData[this.tabIndex]
               let templateId = datas.list.templateId
                //模版选择 
                for(var i in datas.templist){
                    if(datas.templist[i].id==templateId){
                        this.$refs.templateId.setVal(datas.templist[i].selectName)
                        this.$set(this.listData[this.tabIndex].list,"content",datas.templist[i].content)
                    }  
                } 
                //间歇时间单位
                for(var i in this.intermList){
                     if(this.intermList[i].indexNo==datas.list.unitRate){
                          this.$refs.unitRate.setVal(this.intermList[i].selectName)
                          this.$set(this.listData[this.tabIndex].list,"pushMark",this.intermList[i].val)
                     }
                }
                this.$refs.enable.setVal(datas.list.enable*1==0 ? "禁用":"启用")
                this.$nextTick(res=>{
                    this.getValFun()
                })
           })
        },
        
        //下拉选中的值
        getSelectVal(ev){
           this.$set(this.listData[this.tabIndex].list,ev.key,ev.indexNo)
           this.tabBtn({indexNo:this.tabIndex})
        }, 

        //获取input输入的值
        getPoliceSumCount(ev){
           if(!ev){
            this.$set(this.listData[this.tabIndex].list,"policeSumCount",0)
           } 
           this.$nextTick(res=>{
               this.getValFun()
           })
        },
        getPushInput(ev){
           if(!ev){
            this.$set(this.listData[this.tabIndex].list,"pushInput",0)
           } 
           this.$nextTick(res=>{
               this.getValFun()
           })
        },
       
        //获取提交的值
        getValFun(){
           let list = this.listData
           let pushConfigs = []
           for(var i in list){
               if(!list[i].list.pushMark){
                  list[i].list.pushRate = 0
               }else{
                  list[i].list.pushRate = list[i].list.pushInput*list[i].list.pushMark
               }
               pushConfigs.push(list[i].list)
           }
           this.$emit("getVal",pushConfigs)
        }
      }
   }
</script>
<style lang="scss" scoped>
   .line{
      border-bottom: 1px solid #DCDFE6;
      height:40px;
      line-height: 40px;
      width: 100%;
      margin-left:2px;
      .peizhi{
        font-size: 14px;
        color: #606266;
        margin-right:40px;
      }
      .btn{
        height:40px;
        border-bottom: 2px solid rgba(144,144,144,0); 
        margin-right:40px;
        cursor: pointer;
      }
      .btn.active{
        border-bottom: 2px solid #409EFF; 
      }
   }
   .content{
     border: 1px solid #DCDFE6;
     border-radius: 6px;
     padding: 5px 15px;
     box-sizing: border-box;
     max-height: 200px;
     min-height: 100px;
     overflow-y: auto;
   }
</style>